import "./hero.css";
import { CheckCircleIcon } from "lucide-react";
import StartVerifyingRentersButton from "../start-verifying-renters-button";

import RentidLogo from "./../../assets/images/rentid-Horizontal-black-1.svg";

export function Hero() {
  return (
    <section className="heroAlt bannerInnerMain bannerIdMain">
      <div className="hero__inner">
        <div className="hero__logo">
          <img
            src={RentidLogo}
            alt="rentID logo"
            width={240}
            height={72}
            className="hero__logo-image"
          />
        </div>

        <h1 className="hero__title">Everything needed to verify renters</h1>

        <div className="hero__features">
          <div className="hero__feature">
            <CheckCircleIcon className="hero__icon" />
            <span className="hero__feature-text">Instant Checks</span>
          </div>
          <div className="hero__feature">
            <CheckCircleIcon className="hero__icon" />
            <span className="hero__feature-text">AI Powered</span>
          </div>
          <div className="hero__feature">
            <CheckCircleIcon className="hero__icon" />
            <span className="hero__feature-text">Detect Fraud</span>
          </div>
          <div className="hero__feature">
            <CheckCircleIcon className="hero__icon" />
            <span className="hero__feature-text">Access DMV</span>
          </div>
          <div className="hero__feature">
            <CheckCircleIcon className="hero__icon" />
            <span className="hero__feature-text">Validate Insurance</span>
          </div>
        </div>

        <p className="hero__description">
          Approve bookings with confidence, backed by AI Trust and Safety tools
          that outsmart risky rentals.
        </p>
        <div className="hero__cta">
          <div className="hero__cta-stack">
            <StartVerifyingRentersButton />
          </div>
        </div>
      </div>
    </section>
  );
}
